import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './_styles_/ChooseFileButton.css';

ChooseFileButton.propTypes = {
    onFilesSelection: PropTypes.func.isRequired,
    multiple: PropTypes.bool,
    accept: PropTypes.string,
};

function ChooseFileButton(props) {
    const {
        onFilesSelection,
        multiple = false,
        accept = null,
    } = props;
    const { t } = useTranslation();
    const resetValue = (event) => {
        // eslint-disable-next-line no-param-reassign
        event.target.value = null;
    };
    const onFilesChange = (event) => onFilesSelection(event.target.files);
    return (
        <label
            htmlFor="choose-file--button"
            className="choose-file-button"
        >
            <input
                type="file"
                id="choose-file--button"
                onChange={onFilesChange}
                multiple={multiple}
                accept={accept}
                onClick={resetValue}
                hidden
            />
            <FontAwesomeIcon icon="file-upload" />&nbsp;{multiple ? t('file-upload.choose-file.multiple-files') : t('file-upload.choose-file.single-file')}
        </label>
    );
}

export default ChooseFileButton;
